// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3U8_T","info":"Note_info__ZGJ6F","note":"Note_note__D4E3w","actions":"Note_actions__3Jbae"};